import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import firebase from "../../firebase/firebase"; // tu clase compat

const NuevoInsumo = () => {
  const { regionId } = useParams();
  const navigate = useNavigate();

  const [insumo, setInsumo] = useState({
    nombre: "",
    categoria: "",
    precio: "",
    unidadMedida: "",
    imagen: "",
  });

  const [subiendo, setSubiendo] = useState(false);
  const [progreso, setProgreso] = useState(0);

  const handleChange = (e) => {
    setInsumo({
      ...insumo,
      [e.target.name]: e.target.value,
    });
  };

  // 📤 Subida de archivo
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const storageRef = firebase.storage.ref(`insumos/${file.name}`);
    const uploadTask = storageRef.put(file);

    setSubiendo(true);
    setProgreso(0);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const porcentaje = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgreso(porcentaje);
      },
      (error) => {
        console.error("Error subiendo imagen:", error);
        setSubiendo(false);
      },
      async () => {
        const downloadURL = await uploadTask.snapshot.ref.getDownloadURL();
        setInsumo((prev) => ({
          ...prev,
          imagen: downloadURL,
        }));
        setSubiendo(false);
        setProgreso(100);
      }
    );
  };

  // ✅ Guardar en Firestore
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await firebase.db.collection(`productos_${regionId}`).add(insumo);
      navigate(`/catalogo/${regionId}`);
    } catch (error) {
      console.error("Error al registrar insumo:", error);
    }
  };

  return (
    <div className="w-full h-full p-6">
      <h1 className="text-2xl font-bold mb-6">
        ➕ Nuevo Insumo - {regionId.toUpperCase()}
      </h1>

      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md space-y-4">
        <div>
          <label className="block text-sm font-semibold">Nombre</label>
          <input
            type="text"
            name="nombre"
            value={insumo.nombre}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">Categoría</label>
          <input
            type="text"
            name="categoria"
            value={insumo.categoria}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">Precio</label>
          <input
            type="number"
            name="precio"
            value={insumo.precio}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">Unidad de medida</label>
          <textarea
            name="unidadMedida"
            value={insumo.unidadMedida}
            onChange={handleChange}
            rows="3"
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        {/* 📷 Subida de imagen */}
        <div>
          <label className="block text-sm font-semibold">Imagen</label>
          <input type="file" accept="image/*" onChange={handleFileChange} />
          {subiendo && (
            <div className="mt-2 text-sm text-gray-600">
              Subiendo imagen: {progreso.toFixed(0)}%
            </div>
          )}
          {insumo.imagen && (
            <img
              src={insumo.imagen}
              alt="Vista previa"
              className="w-32 h-32 object-cover mt-3 rounded"
            />
          )}
        </div>

        <button
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
        >
          Guardar Insumo
        </button>
      </form>
    </div>
  );
};

export default NuevoInsumo;
